import { useLayoutEffect, useRef } from 'react';

/**
 * Trocar a foto troca as ações dos selos: "Atualizar minha foto" vira "Baixar" e o convite sai. Se o foco
 * estava num desses botões, ele cai no `body`; este hook o devolve ao elemento do `ref` (WCAG 2.4.3). Só age numa
 * troca (da foto ou da coleção já carregada), nunca na primeira carga, e só se o foco se perdeu.
 */
export function useFocoNaTrocaDeFoto<T extends HTMLElement>(temFoto: boolean, colecao: unknown) {
  const ref = useRef<T>(null);
  const anterior = useRef({ temFoto, colecao });

  useLayoutEffect(() => {
    const { temFoto: temFotoAntes, colecao: colecaoAntes } = anterior.current;
    anterior.current = { temFoto, colecao };
    const trocou = temFotoAntes !== temFoto || (colecaoAntes !== undefined && colecaoAntes !== colecao);
    if (trocou && document.activeElement === document.body) ref.current?.focus();
  }, [temFoto, colecao]);

  return ref;
}
